import React from 'react';
import { BillingButtonBarButton } from '../code/enums/Enums';
import ButtonConfirm, { ButtonConfirmSize } from './ButtonConfirm';
import CurrencyModalForm from './modal-forms/CurrencyModalForm';

import '../css/customerbuttonbar.css';
import AuthAdminUserModel from "../code/models/AuthAdminUserModel";
import PaymentInfo from "../code/models/PaymentInfo";
import { formatCurrency } from "../code/helpers/numberFormatting";
import Api_Config from "../code/api/ApiConfig";

interface ICustomerInfoBillingInfoButtonBar {
    currentUser: AuthAdminUserModel;
    paymentInfo: PaymentInfo;
    showTransactionHistory: boolean;
    onButtonClickEvent: (eventButton: BillingButtonBarButton, eventData: any) => void;
}

export default function CustomerInfoBillingInfoButtonBar({ currentUser, paymentInfo, showTransactionHistory, onButtonClickEvent }: ICustomerInfoBillingInfoButtonBar) {
    const [createChargeActive, setCreateChargeActive] = React.useState<boolean>(false);
    const [createCreditActive, setCreateCreditActive] = React.useState<boolean>(false);
    const [warningMessage, setWarningMessage] = React.useState<string | null>(null);
    const company = Api_Config.getSelectedCompany();

    function handleCreatePromotionClick() {
        onButtonClickEvent(BillingButtonBarButton.CreatePromotion, {});
    }

    function handleProcessPaymentsClick(confirm: boolean) {
        if (!confirm) return;
        onButtonClickEvent(BillingButtonBarButton.ProcessPaymets, {});
    }

    function handleTransactionHistoryClick() {
        onButtonClickEvent(BillingButtonBarButton.TransactionHistory, {});
    }

    function postWarningMessage(msg: string) {
        setWarningMessage(msg);
        setTimeout(() => { setWarningMessage(null); }, 8000);
    }

    function onCreateChargeConfirm(isConfirm: boolean, amount?: number, description?: string) {
        setCreateChargeActive(false);
        if (isConfirm && !!amount && !!description) {
            let vals = {
                amount: amount,
                description: description
            };
            onButtonClickEvent(BillingButtonBarButton.CreateCharge, vals);
        } else if (isConfirm) {
            postWarningMessage("Cannot create charge.  Both Amount and Description need to be filled in.");
        }
    }

    function onCreateCreditConfirm(isConfirm: boolean, amount?: number, description?: string) {
        setCreateCreditActive(false);
        if (isConfirm && !!amount && !!description) {
            let vals = {
                amount: amount,
                description: description
            };
            onButtonClickEvent(BillingButtonBarButton.CreateCredit, vals);
        } else if (isConfirm) {
            postWarningMessage("Cannot create credit.  Both Amount and Description need to be filled in.");
        }
    }

    function renderButtons(): React.ReactNode {
        return (
            <React.Fragment>
                <button onClick={() => { setCreateChargeActive(true); }} className="btn btn-outline-primary btn-sm">Create Charge</button>
                <button onClick={() => { setCreateCreditActive(true); }} className="btn btn-outline-primary btn-sm">Create Credit</button>
                {/* <button disabled={true} onClick={handleCreatePromotionClick} className="btn btn-outline-primary btn-sm">Create Promotion</button> */}
                <ButtonConfirm
                    buttonSize={ButtonConfirmSize.Normal}
                    buttonText="Process Payments"
                    confirmMessage="This will process any credits and/or any discounts before charging any balance due. Continue?"
                    confirmTitle="Process Payments"
                    cssClass="btn btn-outline-primary btn-sm"
                    enabled={true}
                    onConfirm={handleProcessPaymentsClick} />
                <button onClick={handleTransactionHistoryClick} className="btn btn-outline-primary btn-sm">
                    {showTransactionHistory ? "Hide Transaction History" : "Transaction History"}</button>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            {!!warningMessage && <div className="alert alert-warning alert-dismissible" role="alert">
                <div>{warningMessage}</div>
                <button type="button" className="btn-close" aria-label="Close"
                    onClick={() => { setWarningMessage(null); }}></button>
            </div>}
            <div className='buttonbar col-md-12'>
                {currentUser.canDoBilling && renderButtons()}
                {paymentInfo != null && paymentInfo.balanceDue > 0 &&
                    <span className="label balancedue">Balance Due: {formatCurrency(paymentInfo.balanceDue, company.currency)}</span>}
                <span className="label">Card On File: {paymentInfo.paymentAccount?.paymentSystemName || "None"}</span>
                {!paymentInfo.paymentAccount?.hasCardOnFile && <span className="label balancedue ms-2">No Credit Card On File</span>}
                <CurrencyModalForm key={"cmfcchg"} modalActive={createChargeActive} modalTitle="Create Charge" modalDescription="Add a charge to the customers account."
                    onConfirm={onCreateChargeConfirm} />
                <CurrencyModalForm key={"cmfccrdt"} modalActive={createCreditActive} modalTitle="Create Credit" modalDescription="Add a credit to the customers account."
                    onConfirm={onCreateCreditConfirm} />
            </div>
        </React.Fragment>
    )
}
